// CONTRACTS_REPO package.json version: 1.109.0
// LLAMA_CONTRACTS_REPO package.json version: 1.10.0

import type { ProtocolKey } from '@silo/types';
import { ADDRESS_ZERO, Address, makeAddressSync } from '@silo/types';

// DO NOT EDIT - this file is generated
export const aPI3AdapterRDNTUSDAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x596E37C72FbeD6cEC8afA4c7e9AC547a76000C6d'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const balancerV2ForLiquidationAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x4a630D0DeF9B65eA12F3aAf63AB9611CEff21582'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const balancerV2PriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd'),
  mainnetLlama: makeAddressSync('0x0F07685A92c9B5c63a9e9Af205948BECeb8eb5f6'),
  mainnetGrand: makeAddressSync('0xbDBBf747402653A5aD6F6B8c49F2e8dCeC37fAcF'),
  arbitrum: makeAddressSync('0x7aAe7D92fbDd1De868c3398E1fade684c000f88d'),
  optimism: makeAddressSync('0x17f2CD2CfE241aFB03950c2ce2bF6b42193d4F04'),
  base: makeAddressSync('0x85b0273b0B415F9e28B9ce820240F4aa097F2a29'),
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x856876834E49F105FdC5cb243Eca893DBac4e477'),
  anvil: makeAddressSync('0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd'),
};

// DO NOT EDIT - this file is generated
export const balancerV2SwapAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA40158686a5bDBe6C3Ea8a32F6e4E045C1C13F90'),
  mainnetLlama: makeAddressSync('0x196D312fd81412B6443620Ca81B41103b4E123FD'),
  mainnetGrand: makeAddressSync('0x12D73b8dC92961C71782154B70416c4A1fb7dD12'),
  arbitrum: makeAddressSync('0xb664Ca87Df549D110C59a96b10278439617D0813'),
  optimism: makeAddressSync('0xA826A337646AC01E89Ff935C996b449e4ba14BdB'),
  base: makeAddressSync('0xBc73c4aAD1aB674Afb3213a399682D70A773c3Dc'),
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xd89d1df879C4f3Eece05c2356441bB4927Df6CD9'),
  anvil: makeAddressSync('0xA40158686a5bDBe6C3Ea8a32F6e4E045C1C13F90'),
};

// DO NOT EDIT - this file is generated
export const chainlinkV3PriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xe37B8c83138caF12E57632D19c06Eb561D47e423'),
  mainnetLlama: makeAddressSync('0xb05F478d93C7063194f37535aD148242B8d1F1B8'),
  mainnetGrand: makeAddressSync('0xa3580D7a163616eb66B85C6FcAdB08dB02da6BEd'),
  arbitrum: makeAddressSync('0x9d0DDE842801448534263FF23C629EDC6B6B31ee'),
  optimism: makeAddressSync('0xE89D07da1438177eaa0AE7277D7D9A4dDdc16C0F'),
  base: makeAddressSync('0x44E9C695624dAd0bB3690A40C90e6D7964B32D3D'),
  lrtbase: makeAddressSync('0xFC403898DBAD4d3F1FC553Fed99d4Dd581BCD42f'),
  local: makeAddressSync('0xb1023Ad017368383A6Cc04c84CFf973371f1d41d'),
  anvil: makeAddressSync('0xe37B8c83138caF12E57632D19c06Eb561D47e423'),
};

// DO NOT EDIT - this file is generated
export const chainlinkV3PriceProviderWithLiquidationAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x2e7406166c29ed4D6017Ab9B78B225f1707dF459'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const chronicleAdapterHYUSDAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0xA910755474F1e52AA7118D4DDa812136FF1BB369'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const chronicleAdapterWUSDMAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x57f3b70b5bD38642b06C5270173139DfC350AFcb'),
  optimism: makeAddressSync('0xe2AC9d6BfF90571F19096971533f26c1a2Cdff13'),
  base: makeAddressSync('0x77cbCB96fFFe44d344c54A5868C49ad1C5AaAC6A'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const constantETHPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0x70073098984050f5563333Be76BCd94D21d8673A'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch230Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x9dcE9e071D83564396707D255a594547dab64B94'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x9dcE9e071D83564396707D255a594547dab64B94'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch231Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xdB1A2f053526329479f7A57C55926885B618dfe1'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xdB1A2f053526329479f7A57C55926885B618dfe1'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch232Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x075dDA01D2f31155b2D50D8a38f813923B356b0E'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x075dDA01D2f31155b2D50D8a38f813923B356b0E'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch233Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x7Ce34fA551D98E6A4e01a70D1720B869024B818B'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x7Ce34fA551D98E6A4e01a70D1720B869024B818B'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch234Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xE951d037Fb1B1a6c1B83c3f9D3ED915d5e97FFC9'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xE951d037Fb1B1a6c1B83c3f9D3ED915d5e97FFC9'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch235Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xf4428d973E4CdfC1d18F61958BaC2FF41776d716'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xf4428d973E4CdfC1d18F61958BaC2FF41776d716'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch236Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xCD7Ac4018B4403ca77B67318fcb46f62c9Caa070'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xCD7Ac4018B4403ca77B67318fcb46f62c9Caa070'),
};

// DO NOT EDIT - this file is generated
export const contributorsAllocationMarch237Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xd17BC37Bb5fc721cAFd51Fc8D1405B87b5Ad46d4'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xd17BC37Bb5fc721cAFd51Fc8D1405B87b5Ad46d4'),
};

// DO NOT EDIT - this file is generated
export const convexSiloWrapperFactoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x634322671380cF1ee7bD555a77fcdD41e680D817'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x634322671380cF1ee7bD555a77fcdD41e680D817'),
};

// DO NOT EDIT - this file is generated
export const convexSiloWrapperMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x76577efdCb4539B7D0aFe6F31d3C76d546E3c79d'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x76577efdCb4539B7D0aFe6F31d3C76d546E3c79d'),
};

// DO NOT EDIT - this file is generated
export const crvUSDMagicianETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x2375EBa92e1b7ace8585AE7e2d23feDc10887493'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const crvUSDViaTriCrvMagicianETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x92d238366dc5EEB63926f61Df208DbE923D5FEC0'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const crvUSDViaUSDCPriceProviderETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0xa1c2837b7A899d6f89282e9bE9f1496D12e86bBa'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const crvUSDViaUSDCPriceProviderETHV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x1781452eD27BbA7fA8932b2D839F244FaCd23a27'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const crvViaTriCrvMagicianETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x9DEaA1Af59932c0D71DE6C04e50581f4605bE416'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const curveCryptoPoolRegistryFetcherAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x62874C6f1254670ae8600A658fF932dadd7D0D20'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x62874C6f1254670ae8600A658fF932dadd7D0D20'),
};

// DO NOT EDIT - this file is generated
export const curveCryptoSwapRegistryFetcherAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xF4999AB1a5a2a2206a71d53Fa31d8Fc9ABF2709D'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xF4999AB1a5a2a2206a71d53Fa31d8Fc9ABF2709D'),
};

// DO NOT EDIT - this file is generated
export const curveLPTokensDetailsFetchersRepositoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xeaC05930c685A168c40C3aA9D017691a88e31fE9'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xeaC05930c685A168c40C3aA9D017691a88e31fE9'),
};

// DO NOT EDIT - this file is generated
export const curveLPTokensMagicianETH128Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xbAcc38fdd9cd697Cd9082Dd6A790b58BCa306288'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xbAcc38fdd9cd697Cd9082Dd6A790b58BCa306288'),
};

// DO NOT EDIT - this file is generated
export const curveLPTokensMagicianETH256Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x0527E1aa1bDf0F6942bb1983A09F81dc34DF8e98'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x0527E1aa1bDf0F6942bb1983A09F81dc34DF8e98'),
};

// DO NOT EDIT - this file is generated
export const curveMainRegistryFetcherAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x0c1cc599D77A1c485775e59591C225D11da1eB5A'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x0c1cc599D77A1c485775e59591C225D11da1eB5A'),
};

// DO NOT EDIT - this file is generated
export const curveMetaPoolFactoryFetcherAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x3eF379D1BCCA69622a447262665837bf4ADA129f'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x3eF379D1BCCA69622a447262665837bf4ADA129f'),
};

// DO NOT EDIT - this file is generated
export const curveNPAPTokensPriceProviderETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA2f8aaA6c4a7a4CD82D8F829D4D257b9C4f49715'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xA2f8aaA6c4a7a4CD82D8F829D4D257b9C4f49715'),
};

// DO NOT EDIT - this file is generated
export const curvePAPTokensPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x4805a86292A91058e8106b6ABC171A7d66018395'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x4805a86292A91058e8106b6ABC171A7d66018395'),
};

// DO NOT EDIT - this file is generated
export const dia2PriceProviderV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x5678Eb5aa136cD06C01F6F6BfF841bcfAd3FaAC8'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const dia3PriceProviderV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xD05Fe8b437401f36904D13225dcc74C572D0450E'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const dia4PriceProviderV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xFa773e2c7df79B43dc4BCdAe398c5DCA94236BC5'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const diaPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x2E4C07a88Ab9CBA800f3D5377E21bBe45405f247'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const diaPriceProviderV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x076Bb60d16e6E0D0C98BFE08A08EeeEFaC89B3C9'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const diaPriceProviderV2Y2KAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x2B6Bbb13B0415ad06F8685A112C00382672a3DD9'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const diaPriceProviderY2KAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x37C470Fff582F6e039407495f65bd87Eb456a417'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const forwarderPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xb664Ca87Df549D110C59a96b10278439617D0813'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xB6bc6be0876546d73e0bdbD2aa76721eBF14B8bE'),
  arbitrum: ADDRESS_ZERO,
  optimism: makeAddressSync('0xCfBEbcf6Bc36F631cBb1011633fFC014dB3dB22d'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xb664Ca87Df549D110C59a96b10278439617D0813'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation1Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xe3006D793B604D8f103e6EaB4cb787fFed59Cf23'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xe3006D793B604D8f103e6EaB4cb787fFed59Cf23'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x25D3A8017793Fb263EFeAecaFd2F2BF34228a10c'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x25D3A8017793Fb263EFeAecaFd2F2BF34228a10c'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation3Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xD6B294bCd6Bc7FB46D84434A384edE079a4bc22E'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xD6B294bCd6Bc7FB46D84434A384edE079a4bc22E'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation4Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x0BC03a02cC7287DE72e1817aEf73de8514d9372b'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x0BC03a02cC7287DE72e1817aEf73de8514d9372b'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation5Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x239f612d65B8b0d0ee830492DB1C4d669A128bDb'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x239f612d65B8b0d0ee830492DB1C4d669A128bDb'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation6Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x44F76E33af2E29AF2C4a57D2cCd5fF0D73644b7a'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x44F76E33af2E29AF2C4a57D2cCd5fF0D73644b7a'),
};

// DO NOT EDIT - this file is generated
export const foundingandEarlyContributorsAllocation7Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xE519F37B8ecC509721E1F49746E10b9f49519c13'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xE519F37B8ecC509721E1F49746E10b9f49519c13'),
};

// DO NOT EDIT - this file is generated
export const fraxCurveMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xE067b967A36A136084Eb9DF0149Dde64F01ea7d1'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xE067b967A36A136084Eb9DF0149Dde64F01ea7d1'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation1Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x83053A452bF28389D7f2584578F3f3e470aadCD7'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xE1224270680132Af13b72377e4C3f867E85450f6'),
  anvil: makeAddressSync('0x83053A452bF28389D7f2584578F3f3e470aadCD7'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation10Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x86c9ec37fB37Ab34790b1052EE00B88f51d56A49'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x86c9ec37fB37Ab34790b1052EE00B88f51d56A49'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation11Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x4eC034ce4659052c4884AA7Ab489a7b23848A455'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x4eC034ce4659052c4884AA7Ab489a7b23848A455'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation12Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x08605E00B877C878d20AA6466f0ac2063f72aB53'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x08605E00B877C878d20AA6466f0ac2063f72aB53'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation13Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA1c7dc4B79D5338b30b6E3a7C1b09429CD42f4DA'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xA1c7dc4B79D5338b30b6E3a7C1b09429CD42f4DA'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation14Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA538907FF0993c67b3600ac1d753c5f2527aBC18'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xA538907FF0993c67b3600ac1d753c5f2527aBC18'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation15Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x85578f50E8Ca7eE328bCbEe41a77715e92d2813a'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x85578f50E8Ca7eE328bCbEe41a77715e92d2813a'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation16Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x895bb5EebBAF9bF9C5788EDb1a20eD6609f17002'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x895bb5EebBAF9bF9C5788EDb1a20eD6609f17002'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation17Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x9BaE7861110AFEb00ecf740D43d94064C94929BB'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x9BaE7861110AFEb00ecf740D43d94064C94929BB'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation18Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x174CE3F08aB1025736FB66d2A964F7F1b6687639'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x174CE3F08aB1025736FB66d2A964F7F1b6687639'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation19Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x01D360c54Eb27A6A95ea1f8E309E5c8263Ed8508'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x01D360c54Eb27A6A95ea1f8E309E5c8263Ed8508'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x09C8971571ca3EEaCDC4BFefD9DAfbA6b0C92110'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x09C8971571ca3EEaCDC4BFefD9DAfbA6b0C92110'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation3Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xac2c2f627B26CAdDfEd33D9AcC1Fc8966995dCC6'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xac2c2f627B26CAdDfEd33D9AcC1Fc8966995dCC6'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation4Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA9F31612D724B4574Ff68B513Bc0856e631b92cc'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xA9F31612D724B4574Ff68B513Bc0856e631b92cc'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation5Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xfCC848A7433B35d2C01d4F94EA3dcFf86d558fEC'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xfCC848A7433B35d2C01d4F94EA3dcFf86d558fEC'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation6Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xf60c1E383FFca607b6207D9003d1F55B51C321E1'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xf60c1E383FFca607b6207D9003d1F55B51C321E1'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation7Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xBd5FB1D64e5464E9CA1565fc37fe3613460c1a2b'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xBd5FB1D64e5464E9CA1565fc37fe3613460c1a2b'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation8Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xf2b4389Dd9035C735818D1AEc881F8361481f276'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xf2b4389Dd9035C735818D1AEc881F8361481f276'),
};

// DO NOT EDIT - this file is generated
export const fundersandAdvisorsAllocation9Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x81b8ae3E394293217363E7CB91949cD8e6103dcc'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x81b8ae3E394293217363E7CB91949cD8e6103dcc'),
};

// DO NOT EDIT - this file is generated
export const futureContributorsandFutureAdvisorsAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x6e5C8274012d9cb386EF8Dcc71a461B71BD07831'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x6e5C8274012d9cb386EF8Dcc71a461B71BD07831'),
};

// DO NOT EDIT - this file is generated
export const gOHMMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xd4240aed295fF0fc2D76b3160E5D63692bA72133'),
  mainnetLlama: makeAddressSync('0xf363C6d369888F5367e9f1aD7b6a7dAe133e8740'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xa7b6CEfc5820b73AC3E5B4C102bcc848620258D9'),
  anvil: makeAddressSync('0xd4240aed295fF0fc2D76b3160E5D63692bA72133'),
};

// DO NOT EDIT - this file is generated
export const gOHMPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xba53D3a08fB8dd4309881B4E8a3bc386ea0DDb1f'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xa3f01C4F30bdE7C8910986E8cfa8484145EFF625'),
  anvil: makeAddressSync('0xba53D3a08fB8dd4309881B4E8a3bc386ea0DDb1f'),
};

// DO NOT EDIT - this file is generated
export const interestRateDataResolverAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xf8E25F35d3F78280D5e817aC08487ad915D81b5D'),
  mainnetLlama: makeAddressSync('0x13b7f88100E291D6f7AacA22300fbe91ac2BB253'),
  mainnetGrand: makeAddressSync('0xCb6CcBd979aa167b81411e672050c01826d715EC'),
  arbitrum: makeAddressSync('0x8ff5be1DDD211c925E3Ce06b86083AeC94e8F0Ce'),
  optimism: makeAddressSync('0xb59605f42A1c564aacc9387132Ad712295b21E55'),
  base: makeAddressSync('0x268Fc6C5Eb17BE53a8670895be62B414c3E636Ce'),
  lrtbase: makeAddressSync('0xd3De080436b9d38DC315944c16d89C050C414Fed'),
  local: makeAddressSync('0x0B3105937e111cD9419E2150E0e34e5ECf0d1f30'),
  anvil: makeAddressSync('0xf8E25F35d3F78280D5e817aC08487ad915D81b5D'),
};

// DO NOT EDIT - this file is generated
export const interestRateModelAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x9AB17170dA72b96Cc9e91095c6c2565587770B23'),
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const interestRateModelV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314'),
  mainnetLlama: makeAddressSync('0x408822E4E8682413666809b0655161093cd36f2b'),
  mainnetGrand: makeAddressSync('0x03FF53ee6B0c8221E5cf3829Db1A1B2d5D26C821'),
  arbitrum: makeAddressSync('0x374D79ef2A75d5D25A4Ce163D85AB0b579171d6c'),
  optimism: makeAddressSync('0xb562b6CdEEE3ec10E4803B8dcfef81a32074e6B5'),
  base: makeAddressSync('0xf1268Fd0F285fCDcA2bC130E1B44229079487DD1'),
  lrtbase: makeAddressSync('0xD0F2E27248838F745C542ACC07e9B25d21780352'),
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x76074C0b66A480F7bc6AbDaA9643a7dc99e18314'),
};

// DO NOT EDIT - this file is generated
export const interestRateModelXAIAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xa5AcA906dcCD6a7A63CF28473B38451a97919f88'),
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const liquidationHelperAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x931cf9F135a0cd54922256aAc33ca6151Ed735d3'),
  mainnetLlama: makeAddressSync('0x116C85d56002566223D5560268E04054D90d7B47'),
  mainnetGrand: makeAddressSync('0xFcc5C41bed687D9c8286b64D7Cd190Ae9E953A23'),
  arbitrum: makeAddressSync('0x069a9ad00821D359f6D667be56d35b49D7ad3a18'),
  optimism: makeAddressSync('0xc3f01B8c6B0338c952a5456e30a9FC26468C052A'),
  base: makeAddressSync('0xF89E18019A0bDC92dE8cc75633cC45014De732c8'),
  lrtbase: makeAddressSync('0xD4576D3B8CcEA7545b8F4cAB2671CF7b712fb73B'),
  local: makeAddressSync('0xF2969cCa4C85193d00Fe6c83323fe7EE8FE10726'),
  anvil: makeAddressSync('0x931cf9F135a0cd54922256aAc33ca6151Ed735d3'),
};

// DO NOT EDIT - this file is generated
export const lusd3CrvMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x4166487056A922D784b073d4d928a516B074b719'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x4166487056A922D784b073d4d928a516B074b719'),
};

// DO NOT EDIT - this file is generated
export const manualLiquidationAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x015BBC6cA60390f3b48c63773f1b7022B14cF76D'),
  mainnetLlama: makeAddressSync('0x557d83ed357208a97A83f04D073364fd68b36937'),
  mainnetGrand: makeAddressSync('0xC99519F2a25c7Ed868D928a50dd1Fe603df14d6A'),
  arbitrum: makeAddressSync('0x26D1857a87d733fBA7a405767daE3C3C55c49C35'),
  optimism: makeAddressSync('0x662c3aFD2a1B5912C8c798AF84f5ABe25D33e5fC'),
  base: makeAddressSync('0x92cECB67Ed267FF98026F814D813fDF3054C6Ff9'),
  lrtbase: makeAddressSync('0x66F61715A887AAfa0F585F72b3C626f9557601Fb'),
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x015BBC6cA60390f3b48c63773f1b7022B14cF76D'),
};

// DO NOT EDIT - this file is generated
export const oHMMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xD4BdDdcA31668F37DBA5115f68422D043CB5EE08'),
  mainnetLlama: makeAddressSync('0x92cECB67Ed267FF98026F814D813fDF3054C6Ff9'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x3085E55390321130B4C31737a699374BC4D069Eb'),
  anvil: makeAddressSync('0xD4BdDdcA31668F37DBA5115f68422D043CB5EE08'),
};

// DO NOT EDIT - this file is generated
export const pRBMathCommonAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x5Dea8BBCC1FcA0AAA72872AbA72990278D2bdc1B'),
  mainnetLlama: makeAddressSync('0xBc73c4aAD1aB674Afb3213a399682D70A773c3Dc'),
  mainnetGrand: makeAddressSync('0xfda22a78035A8D7791867B17AEC537babbCff421'),
  arbitrum: makeAddressSync('0xb0abdc3609E253D26A0cD86C31180f9630a07091'),
  optimism: makeAddressSync('0x142997a09E822d1c9a9AB150179E754b0Ce98681'),
  base: makeAddressSync('0xcDcBbbe6608eAC3Fd8e311Bb81038632f01133f9'),
  lrtbase: makeAddressSync('0xb59605f42A1c564aacc9387132Ad712295b21E55'),
  local: makeAddressSync('0x40b3bEFD9Ef44aD919AAB1cf1025B6c8B3aC437C'),
  anvil: makeAddressSync('0x5Dea8BBCC1FcA0AAA72872AbA72990278D2bdc1B'),
};

// DO NOT EDIT - this file is generated
export const pRBMathSD59x18Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xd0Ad0CDf6C0a08048d95A140fd0eECbeb7Ea91F2'),
  mainnetLlama: makeAddressSync('0x0f9d4fa99A0ca3c3c0DEdd287531c04E054c5f39'),
  mainnetGrand: makeAddressSync('0x66c91b469c222fC40a549Fed4eB5378E07EfbcB3'),
  arbitrum: makeAddressSync('0xAE34023d03b44A09447FfC70FEF370012Cf6d944'),
  optimism: makeAddressSync('0xD0F2E27248838F745C542ACC07e9B25d21780352'),
  base: makeAddressSync('0x0F07685A92c9B5c63a9e9Af205948BECeb8eb5f6'),
  lrtbase: makeAddressSync('0x142997a09E822d1c9a9AB150179E754b0Ce98681'),
  local: makeAddressSync('0x9FB39Ef47CCDE14990Da65E551f1E64e5D380C0F'),
  anvil: makeAddressSync('0xd0Ad0CDf6C0a08048d95A140fd0eECbeb7Ea91F2'),
};

// DO NOT EDIT - this file is generated
export const pendleEzETH250424PriceProviderEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x7a90F2b9f72bA840A55557b5c6fa2E3b83B86037'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x7a90F2b9f72bA840A55557b5c6fa2E3b83B86037'),
};

// DO NOT EDIT - this file is generated
export const pendleEzETH270624PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x593B383751ED87f172cDB36733b587Eb4d430aF1'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendleEzethEthMagicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xadf6A18168c710de96E421A3a8eaaFfF0c5D59Ed'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xadf6A18168c710de96E421A3a8eaaFfF0c5D59Ed'),
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26DEC2024MagicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x60174496accaEb8B0815C9Fb75BaC50230D40266'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x60174496accaEb8B0815C9Fb75BaC50230D40266'),
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26DEC2024PriceProviderEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xBc0131AA1FF58F628ceAcE15751F703E17E24C69'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xBc0131AA1FF58F628ceAcE15751F703E17E24C69'),
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26SEP2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xB34330715Bb795929Ef4a308E49DbEe6D33B644f'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26SEP2024MagicianArbV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x7C05202E1E79C896B3633308dE0439b4B19c44bE'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26SEP2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x20C3AAC97E1c85E66488c1aB960268561A0a3c4A'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26SEP2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x994E89D975222bcC6b9c18d271c4f0f6aae45Ec3'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTEzETH26SEP2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x4511eB602Ed8B15b3F1f1640b0b60D75191AE43a'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTPufETH26DEC2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x30aaA84098CD71781aafCbfE8bB06aC6643a29DC'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTPufETH26DEC2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xe8B0409abba7832765Ca2517e2BD6afeECfDFa99'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTPufETH26SEP2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x7dcb5C4C9D52B0445DB48bDa9e3Ba07fD6eF375B'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTPufETH26SEP2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xcD280d15c507CD5fC08ba23Ee83210d673351674'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26DEC2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x9a8C0394839F958bDA8E80dAAAd20B4680199e14'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26DEC2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x4c8fc0691699710524D904B1d8DE4cFB216189D6'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26DEC2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xF264e31c929f0978a83d3D8f9368df163D4e27D2'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26DEC2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x06A371cadeee25499C0Ff5AF57DE1e83BB506330'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26JUN2025MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x7c185b43A74a8D1c5aF5E5b350d8D9762baDC577'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26JUN2025PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xCdC12f8a4f550342C22497a1cE9039069d463A23'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26SEP2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x8B8acE2E911A270eA7D911bF5009220f59d358E6'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26SEP2024MagicianArbV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x7a90F2b9f72bA840A55557b5c6fa2E3b83B86037'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTRsETH26SEP2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x8cA6cD58320e4b6D49BEE4E59F86E81D6af88bF4'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTSUSDe26SEP2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x581E1A917E99F1B3bC5eB8985959581C951fA8ab'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTSUSDe26SEP2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xE96410f6A45f2dc4BAe575E2E6257b68A2B3dFc9'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTUSDe28NOV2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xE93CD89E29B5D22bED68dAe8448E241D5ed6d7C3'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTUSDe28NOV2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xBfDC7E1e6A101Ce70072dE388732F373Efd306a9'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTUSDe29AUG2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x7dD2D97DCb783b2F5422d6767327411Ce9e9b0eB'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTUSDe29AUG2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xC662194321D50CbF8A148951f9EfB6E7b9f0664f'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26DEC2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xAaB8efb6F91093c5c3f10B1Cab4071D8E84a8976'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26DEC2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xDA91d956498d667f5DB71eEcd58Ba02C4B960a53'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26DEC2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x7ef3055d2B76214Df9Ae74D42944e2917D08Bd78'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26DEC2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x8a08C83e3a41Bf8547BD1cdBd69C19331808b4bf'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26JUN2025MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x0743884E5B0Acbab163Bcd65f87D421d6543dfcc'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26JUN2025PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x0b3f8E6D9aa88Ce5D40238690D6903a90c6Acac2'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26SEP2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x2003c79f788B884fEC30994ed47a20a3841c9752'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26SEP2024MagicianArbV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x4129FD4f80f52850A1faDaA78Ba5AA46b9E8716d'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26SEP2024MagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x539AC1fa1EeB2986Bb772e965502B2d5913d53A4'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26SEP2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x2736DFDa36766580a053DcaC91b662336C125Edb'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTWeETH26SEP2024PriceProviderGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x72fBDDb4Ad99a7002906BE3984eCaF0e30EFFf73'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTrsETH27JUN2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xA0380d22A4Ee658e9706b390ddf9646f184dd521'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTrsETH27JUN2024MagicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x375037Cc9168c0ee3E5Ec561035802dBe17a5B3c'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x375037Cc9168c0ee3E5Ec561035802dBe17a5B3c'),
};

// DO NOT EDIT - this file is generated
export const pendlePTrsETH27JUN2024PriceProviderEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x4129FD4f80f52850A1faDaA78Ba5AA46b9E8716d'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x4129FD4f80f52850A1faDaA78Ba5AA46b9E8716d'),
};

// DO NOT EDIT - this file is generated
export const pendlePTrswETH27JUN2024MagicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x1f6285e2e03832A6F01c2b3d4AC5cb5B73817fBD'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x1f6285e2e03832A6F01c2b3d4AC5cb5B73817fBD'),
};

// DO NOT EDIT - this file is generated
export const pendlePTrswETH27JUN2024PriceProviderEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x9b5136ABF1B8253C34e19aD82B5493aD02ffe263'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x9b5136ABF1B8253C34e19aD82B5493aD02ffe263'),
};

// DO NOT EDIT - this file is generated
export const pendlePTweETH27JUN2024MagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xCfBEbcf6Bc36F631cBb1011633fFC014dB3dB22d'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendlePTweETH27JUN2024MagicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x5B7DF1463796f73A34BcEe8A24b0D4d3A93EE53d'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x5B7DF1463796f73A34BcEe8A24b0D4d3A93EE53d'),
};

// DO NOT EDIT - this file is generated
export const pendleRsETH27JUN2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x6bF5529aFCc07b669f37D9D29C5118d7a5117A0D'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendleWeETH27JUN2024PriceProviderArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xeC862b4671A1a706Ec13aAE8510E8E567f6B6602'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendleWeETH27JUN2024PriceProviderEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xc6A5d700906c604f2045e3954745026Aa7A79680'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xc6A5d700906c604f2045e3954745026Aa7A79680'),
};

// DO NOT EDIT - this file is generated
export const pendleWeeth250424PriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x528E61638a72E60a1a127A80734B24D6369591a2'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const pendleWeethMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x6cA841F23e270D5f2e71F818b5385E05c4A18462'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const priceProvidersRepositoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F'),
  mainnetLlama: makeAddressSync('0xa40111994F44C8add82eF495269e19109c9A982A'),
  mainnetGrand: makeAddressSync('0xE93CD89E29B5D22bED68dAe8448E241D5ed6d7C3'),
  arbitrum: makeAddressSync('0x5bf4E67127263D951FC515E23B323d0e3b4485fd'),
  optimism: makeAddressSync('0x1E915d8950f0C6bf9d01C603D33c50b6110beDA3'),
  base: makeAddressSync('0xF380F025675A868eD5614a1Dd77c6b05f4147004'),
  lrtbase: makeAddressSync('0x17f2CD2CfE241aFB03950c2ce2bF6b42193d4F04'),
  local: makeAddressSync('0xc467195154B7729Cc9161B18e5Acc83dFa42E941'),
  anvil: makeAddressSync('0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F'),
};

// DO NOT EDIT - this file is generated
export const sTETHMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xC07B94b2A1F1bfc7381Ffc72fE217063bF6946fb'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x1EF928d4b64A52B0A1De699aDdC138FD9803a678'),
  anvil: makeAddressSync('0xC07B94b2A1F1bfc7381Ffc72fE217063bF6946fb'),
};

// DO NOT EDIT - this file is generated
export const sUSDeViaCurveMaigicianEthAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0xc60d70867ED895b6CBE056e0c1D0148953742043'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloCollateralOnlyFactoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xfB94C3780C85eB714aD9a1Ca9Cd9F8DB18208Cb1'),
  mainnetLlama: makeAddressSync('0xBd7a2fC68cD1C5700E8A4A82544c07f1a16922D1'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xa82837464c1DA27935E750717A423E738B408878'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xfB94C3780C85eB714aD9a1Ca9Cd9F8DB18208Cb1'),
};

// DO NOT EDIT - this file is generated
export const siloConvexFactoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x6d4A256695586F61b77B09bc3D28333A91114d5a'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x6d4A256695586F61b77B09bc3D28333A91114d5a'),
};

// DO NOT EDIT - this file is generated
export const siloConvexStateChangesHandlerAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x857c44b994a9BeeDcF5FA4B7E9fAf48556058F59'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x857c44b994a9BeeDcF5FA4B7E9fAf48556058F59'),
};

// DO NOT EDIT - this file is generated
export const siloDAOTreasuryAllocationAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xcFEedb0219A99bE73dFE04B2A9905a109Cf87823'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xcFEedb0219A99bE73dFE04B2A9905a109Cf87823'),
};

// DO NOT EDIT - this file is generated
export const siloFactoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x4D919CEcfD4793c0D47866C8d0a02a0950737589'),
  mainnetLlama: makeAddressSync('0x2c0fA05281730EFd3ef71172d8992500B36b56eA'),
  mainnetGrand: makeAddressSync('0xB7d391192080674281bAAB8B3083154a5f64cd0a'),
  arbitrum: makeAddressSync('0x4166487056A922D784b073d4d928a516B074b719'),
  optimism: makeAddressSync('0x6B14c4450a29Dd9562c20259eBFF67a577b540b9'),
  base: makeAddressSync('0x408822E4E8682413666809b0655161093cd36f2b'),
  lrtbase: makeAddressSync('0x2899b0C131225CbcE912Ba14Bbb7e1C88f2462B5'),
  local: makeAddressSync('0x976ED7147392f4F3d49ebd837A8f107a9853E894'),
  anvil: makeAddressSync('0x4D919CEcfD4793c0D47866C8d0a02a0950737589'),
};

// DO NOT EDIT - this file is generated
export const siloGovernanceTokenAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xC38730f0619116b3EC1206d33496c1778E115f0A'),
  anvil: makeAddressSync('0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8'),
};

// DO NOT EDIT - this file is generated
export const siloGovernorAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xA89163F7B2D68A8fbA6Ca36BEEd32Bd4f3EeAf61'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0xA89163F7B2D68A8fbA6Ca36BEEd32Bd4f3EeAf61'),
};

// DO NOT EDIT - this file is generated
export const siloGovernorV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x7051a585729959562Ef1ece022A5b26e66FbADf6'),
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x6c1603aB6CecF89DD60C24530DdE23F97DA3C229'),
  mainnetLlama: makeAddressSync('0x361384A0d755f972E5Eea26e4F4efBAf976B6461'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x4999873bF8741bfFFB0ec242AAaA7EF1FE74FCE8'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x6c1603aB6CecF89DD60C24530DdE23F97DA3C229'),
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForARBAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xCC4933B0405Ae9DDFE05a54d20f56A0447c9EBcF'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForOPAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: makeAddressSync('0x847D9420643e117798e803d9C5F0e406277CB622'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForSiloAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0xB14F20982F2d1E5933362f5A796736D9ffa220E4'),
  arbitrum: makeAddressSync('0x7e5BFBb25b33f335e34fa0d78b878092931F8D20'),
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0x626e6A8D4EB33D77A8b631ABfE2E98dA69E3100e'),
  lrtbase: makeAddressSync('0x5825E982Dec576B6e7743be493fd8807A610860B'),
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForSiloV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xbDBBf747402653A5aD6F6B8c49F2e8dCeC37fAcF'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForSilo_v1Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0xbF1b7110715aca699173471b3DCe4B38c44f95Ec'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesControllerV2ForWETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xB03A9C6b6eBDe80BC358c1bF8694f41B4f83Bb9D'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloIncentivesController_aRBAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xd592F705bDC8C1B439Bd4D665Ed99C4FaAd5A680'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const siloLensAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x0e466FC22386997daC23D1f89A43ecb2CB1e76E9'),
  mainnetLlama: makeAddressSync('0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF'),
  mainnetGrand: makeAddressSync('0x331243a425F7EE2468f0FddCe5cD83f58733Cc1C'),
  arbitrum: makeAddressSync('0xBDb843c7a7e48Dc543424474d7Aa63b61B5D9536'),
  optimism: makeAddressSync('0xd3De080436b9d38DC315944c16d89C050C414Fed'),
  base: makeAddressSync('0x196D312fd81412B6443620Ca81B41103b4E123FD'),
  lrtbase: makeAddressSync('0xE89D07da1438177eaa0AE7277D7D9A4dDdc16C0F'),
  local: makeAddressSync('0xa089dA1389b20186DEC6D217A606d146E753315f'),
  anvil: makeAddressSync('0x0e466FC22386997daC23D1f89A43ecb2CB1e76E9'),
};

// DO NOT EDIT - this file is generated
export const siloLiquidationLensAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xacf3Dd85b43c2F603604aAA2867f79f72316853e'),
  mainnetLlama: makeAddressSync('0x95fB4B8EEf1dbdDb6937974EA42cEC14dAa1204e'),
  mainnetGrand: makeAddressSync('0xA5B7Fa178151B29cb87b6c196D88249d94151A3B'),
  arbitrum: makeAddressSync('0x581E1A917E99F1B3bC5eB8985959581C951fA8ab'),
  optimism: makeAddressSync('0x5825E982Dec576B6e7743be493fd8807A610860B'),
  base: makeAddressSync('0xf363C6d369888F5367e9f1aD7b6a7dAe133e8740'),
  lrtbase: makeAddressSync('0x2265B128491c6429B2F65E1964949B4168110A1e'),
  local: makeAddressSync('0x968A588f82e9CC5479fe5238A4b4f93cFDa6b395'),
  anvil: makeAddressSync('0xacf3Dd85b43c2F603604aAA2867f79f72316853e'),
};

// DO NOT EDIT - this file is generated
export const siloRepositoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xd998C35B7900b344bbBe6555cc11576942Cf309d'),
  mainnetLlama: makeAddressSync('0xBCd67f35c7A2F212db0AD7f68fC773b5aC15377c'),
  mainnetGrand: makeAddressSync('0xbACBBefda6fD1FbF5a2d6A79916F4B6124eD2D49'),
  arbitrum: makeAddressSync('0x8658047e48CC09161f4152c79155Dac1d710Ff0a'),
  optimism: makeAddressSync('0xD2767dAdED5910bbc205811FdbD2eEFd460AcBe9'),
  base: makeAddressSync('0xa42001D6d2237d2c74108FE360403C4b796B7170'),
  lrtbase: makeAddressSync('0x1E915d8950f0C6bf9d01C603D33c50b6110beDA3'),
  local: makeAddressSync('0x61AE8B429f47c01945D050a69e5eCADab569B62a'),
  anvil: makeAddressSync('0xd998C35B7900b344bbBe6555cc11576942Cf309d'),
};

// DO NOT EDIT - this file is generated
export const siloRouterAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xb2374f84b3cEeFF6492943Df613C9BcF45322a0c'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x871Ea4c95F204AC944Cdd91cf5FAafD166fbD887'),
  arbitrum: makeAddressSync('0x9992f660137979C1ca7f8b119Cd16361594E3681'),
  optimism: makeAddressSync('0xC66D2a90c37c873872281a05445EC0e9e82c76a9'),
  base: makeAddressSync('0x757748e1A208f23bfeb08b925Fac64971eF0584E'),
  lrtbase: makeAddressSync('0xc3f01B8c6B0338c952a5456e30a9FC26468C052A'),
  local: makeAddressSync('0x0b5a2A8a8F0aCfB9D463CAa6b784B52e860A5F04'),
  anvil: makeAddressSync('0xb2374f84b3cEeFF6492943Df613C9BcF45322a0c'),
};

// DO NOT EDIT - this file is generated
export const siloRouterV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x8658047e48CC09161f4152c79155Dac1d710Ff0a'),
  mainnetLlama: makeAddressSync('0xF380F025675A868eD5614a1Dd77c6b05f4147004'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x8658047e48CC09161f4152c79155Dac1d710Ff0a'),
};

// DO NOT EDIT - this file is generated
export const siloSnapshotWrapperAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xCE3d2E0331D6776C79F329140d7aCE2E94B168A4'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x4f2999a82EaC9E9ca1D4C679D28CfEaa93e378d8'),
  anvil: makeAddressSync('0xCE3d2E0331D6776C79F329140d7aCE2E94B168A4'),
};

// DO NOT EDIT - this file is generated
export const timelockControllerAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xe1F03b7B0eBf84e9B9f62a1dB40f1Efb8FaA7d22'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x1D272bD3f8340B457B9D9ae3C99ee78c3E5BEE47'),
  anvil: makeAddressSync('0xe1F03b7B0eBf84e9B9f62a1dB40f1Efb8FaA7d22'),
};

// DO NOT EDIT - this file is generated
export const tokensFactoryAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x0e37Df413f97fC198a84A21BC463C41b516AD622'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x7Ed1160719AB280760FAa0Ba26CF13139904CbA5'),
  arbitrum: makeAddressSync('0xE067b967A36A136084Eb9DF0149Dde64F01ea7d1'),
  optimism: makeAddressSync('0x8A3C8F33b36B935f5E68108E664FB139B54eC0E8'),
  base: makeAddressSync('0x0f9d4fa99A0ca3c3c0DEdd287531c04E054c5f39'),
  lrtbase: makeAddressSync('0x19ee5a234Bf93f166E1664812b1E6E58593a4529'),
  local: makeAddressSync('0x689364100a7598309380e68AbcFB0cb54067f6c7'),
  anvil: makeAddressSync('0x0e37Df413f97fC198a84A21BC463C41b516AD622'),
};

// DO NOT EDIT - this file is generated
export const tokensFactoryConvexAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x5bf4E67127263D951FC515E23B323d0e3b4485fd'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: makeAddressSync('0x5bf4E67127263D951FC515E23B323d0e3b4485fd'),
};

// DO NOT EDIT - this file is generated
export const tokensFactoryV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0xB6AdBb29f2D8ae731C7C72036A7FD5A7E970B198'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const towerAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xF6a89F965E8c94da53f03b84563f103126ba5f23'),
  mainnetLlama: makeAddressSync('0x9d33d45AA7E1B45c65EA4b36b0c586B58a4796cE'),
  mainnetGrand: makeAddressSync('0x0AB251C6dAFB5598d6a6374030B1E0bfA6687dEb'),
  arbitrum: makeAddressSync('0x4182ad1513446861Be314c30DB27C67473541457'),
  optimism: makeAddressSync('0x413e64c7407D292D3EAcCc7FB878F3bC3522BB93'),
  base: makeAddressSync('0x22AacdEc57b13911dE9f188CF69633cC537BdB76'),
  lrtbase: makeAddressSync('0x847D9420643e117798e803d9C5F0e406277CB622'),
  local: makeAddressSync('0x9D346e4b6EcbFa2b09A438bA75DC09C5E0E887cf'),
  anvil: makeAddressSync('0xF6a89F965E8c94da53f03b84563f103126ba5f23'),
};

// DO NOT EDIT - this file is generated
export const uSDCMagicianBaseAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0x29752e1bbD2d67992a4A28900B4122FF99Ad4FCa'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const uSDCMagicianGrandAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x33775238B2f552832b2711dB003D646850f27097'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const uSDCMagicianOptimismAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: makeAddressSync('0x480EB6D6e5DD228aFDc0dCDcB81188B95C2EcF10'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const uniBTCAdapterAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: makeAddressSync('0x14c646C6Cf518cB6B515f95771cdb4948d2ACcd9'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const uniswapV3PriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x9D46F86516d6083ACA3F9850D060CB62CD0F6924'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xa44030057A005995851ae36553caeF7551d36BDd'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x64e7AF8Cc573157dB2A872Eea39eCC36E05B0348'),
  anvil: makeAddressSync('0x9D46F86516d6083ACA3F9850D060CB62CD0F6924'),
};

// DO NOT EDIT - this file is generated
export const uniswapV3PriceProviderV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xFAe64471ae04068e872C6A73C9F5a255c37dDbDC'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x23755639583e92Db7bf1702E721DBc18fB99ba90'),
  arbitrum: makeAddressSync('0x124230c23ab32E22c69aCB48b38B4Dbaaaf74a40'),
  optimism: makeAddressSync('0xfed9c57cd8B76a4d197496eDDd8ae7A091DFEF1B'),
  base: makeAddressSync('0xA95aa71AEce270C7f2c777B1020A97503F7bd0a5'),
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x04987cf8dA5fb969ACCEEe62ca720763413d4192'),
  anvil: makeAddressSync('0xFAe64471ae04068e872C6A73C9F5a255c37dDbDC'),
};

// DO NOT EDIT - this file is generated
export const uniswapV3PriceProviderV3Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: makeAddressSync('0x268Fc6C5Eb17BE53a8670895be62B414c3E636Ce'),
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const uniswapV3PriceProviderXAIAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x2f0a401966219351887A608493954A7078ef1bc0'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xB14Ed2AeF4B36FA8CD1BDC5304e80620D6785172'),
  anvil: makeAddressSync('0x2f0a401966219351887A608493954A7078ef1bc0'),
};

// DO NOT EDIT - this file is generated
export const uniswapV3SwapAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xff36fdF7DE2aa239b0295d406A6ca5c25c6c9e99'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x7a9AeBAf5A56E51cDe9BE7594e9257962a827613'),
  arbitrum: makeAddressSync('0xBe06E00666Dd1F42b0c65cFE17158906EfFb441E'),
  optimism: makeAddressSync('0xD4576D3B8CcEA7545b8F4cAB2671CF7b712fb73B'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x98367eD5e4A15a8b89De22cEEa120Ff6104E200E'),
  anvil: makeAddressSync('0xff36fdF7DE2aa239b0295d406A6ca5c25c6c9e99'),
};

// DO NOT EDIT - this file is generated
export const uniswapV3SwapV2Address: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x96fBF6F0A431e64e05E22e5dBf6f1d92E5dda81f'),
  mainnetLlama: makeAddressSync('0xF89E18019A0bDC92dE8cc75633cC45014De732c8'),
  mainnetGrand: makeAddressSync('0xE856A3a604eA6795B9A3f4b195A2fF07463d2b3a'),
  arbitrum: makeAddressSync('0x597283Aa3e8f4A271E4874bC494448Bf37172c63'),
  optimism: makeAddressSync('0x66F61715A887AAfa0F585F72b3C626f9557601Fb'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x7436aB8c5F057F93D389C246f9F39E6c3BeacCA6'),
  anvil: makeAddressSync('0x96fBF6F0A431e64e05E22e5dBf6f1d92E5dda81f'),
};

// DO NOT EDIT - this file is generated
export const wSTETHMagicianAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xa2ed88339701C209f3A72215164f0D97e7403A05'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x66d6076712edc92d6999A638AeB4F565eC853DbE'),
  anvil: makeAddressSync('0xa2ed88339701C209f3A72215164f0D97e7403A05'),
};

// DO NOT EDIT - this file is generated
export const wSTETHPriceByChainlinkArbitrumAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0xf1268Fd0F285fCDcA2bC130E1B44229079487DD1'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const wSTETHPriceByChainlinkOptimismAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: makeAddressSync('0x9DEaA1Af59932c0D71DE6C04e50581f4605bE416'),
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const wSTETHPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0xE56955B54Ae444d73A52aD3179941E1700910d35'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: makeAddressSync('0x3bc972757798c346bbc87EDE8d31cFfCAC511904'),
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0xAe91E8B8653d87135a095503A2aB1E2506F4Fab6'),
  anvil: makeAddressSync('0xE56955B54Ae444d73A52aD3179941E1700910d35'),
};

// DO NOT EDIT - this file is generated
export const wrappedUsdPlusMagicianArbAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x60174496accaEb8B0815C9Fb75BaC50230D40266'),
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const wrappedUsdPlusMagicianBaseAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0xDe73c3be8018beE324E87a570F4daaD9ff16E6B0'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const wrappedUsdPlusPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: makeAddressSync('0x76125B2C22a01E4ab7B85886272B3C8B6B77c7CB'),
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0x08185627A848C2CB8886bd89863869f41907FFF9'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const wsuperOETHbPriceProviderAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: ADDRESS_ZERO,
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: makeAddressSync('0x6B14c4450a29Dd9562c20259eBFF67a577b540b9'),
  lrtbase: ADDRESS_ZERO,
  local: ADDRESS_ZERO,
  anvil: ADDRESS_ZERO,
};

// DO NOT EDIT - this file is generated
export const xAICurveMagicianETHAddress: Record<ProtocolKey, Address> = {
  mainnetLegacy: makeAddressSync('0x8458396264bAaAfC9F6E6437a264636ce7c07c43'),
  mainnetLlama: ADDRESS_ZERO,
  mainnetGrand: ADDRESS_ZERO,
  arbitrum: ADDRESS_ZERO,
  optimism: ADDRESS_ZERO,
  base: ADDRESS_ZERO,
  lrtbase: ADDRESS_ZERO,
  local: makeAddressSync('0x100119059bF9a024b3891145415ad8f5C65Dd544'),
  anvil: makeAddressSync('0x8458396264bAaAfC9F6E6437a264636ce7c07c43'),
};

